"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable global-require */
var _default = exports["default"] = {
  framerate: 24,
  images: [require('./cornerSprite.png')],
  frames: [[592, 2, 291, 286, 0, -131, -127], [2, 292, 291, 286, 0, -131, -127], [297, 292, 291, 286, 0, -131, -127], [297, 2, 291, 286, 0, -131, -127], [2, 2, 291, 286, 0, -131, -127]],
  animations: {
    still: {
      frames: [0],
      speed: 1
    },
    'speech loop': {
      frames: [1, 1, 1, 2, 2, 2, 3, 3, 3, 1, 1, 1, 3, 3, 3, 4, 4, 4, 2, 2, 2, 1, 1, 3, 3, 3, 1, 1, 1, 3, 3, 2, 2, 2, 1, 1, 1, 0, 0, 3, 3, 3, 2, 2, 2, 3, 3, 3, 3],
      speed: 1
    }
  }
};